<template> 
    <span v-if="varientObj!==undefined">
        <span style="margin-left:20px;font-size:15px">
            <i class="fa fa-cog"></i>
        </span>
        <span style="margin-left:5px" class="varient-btn varien-btn-class">
            <el-cascader class="" expand-trigger="hover" size="small" :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
        </span>
        <!-- <span style="font-size:13px;">{{activeOption?'查询变式: ':'选择查询变式'}}</span>
        <span style="font-size:13px;color:#20a0ff">{{activeLabel}}</span> -->
    </span>
</template>
<script>
import * as utils from '../../store/utils'
export default {
    props: ['varientObj'],
    created() {
        //从LocalStorage加载变式
        this.varient = this.varientObj || {};
        this.loadVarients();
        if (!this.varients.hasOwnProperty(this.path)) {
            this.varients[this.path] = {};
        }
        this.defaultVarient = JSON.parse(JSON.stringify(this.varient || {}));
    },
    data() {
        return {
            defaultVarient: {},
            path: this.$route.path,
            varients: {},
            systemOptions: [{
                value: 'systemDefault',
                label: '系统默认',
            }, {
                value: 'divider',
                label: '－－－－－－－－－－－－－－－－－－',
                disabled: true
            }, {
                value: 'save',
                label: '保存'
            }, {
                value: 'saveAs',
                label: '另存为...'
            }, {
                value: 'delete',
                label: '删除当前变式',
            }],
            selectedOptions: [],
            activeOption: ''
        }
    },
    computed: {
        currentVarients: function() {
            return this.varients[this.path];
        },
        options: function() {
            return Object.values(this.currentVarients).concat(this.systemOptions);
        },
        activeLabel: function() {
            if (this.currentVarients.hasOwnProperty(this.activeOption)) {
                return this.currentVarients[this.activeOption].label;
            } else if (this.activeOption === 'systemDefault') {
                return '系统默认';
            }
            return '';
        }
    },
    methods: {
        handleChange(selectedOption) {
            var _this=this;
            var value = selectedOption[0];
            if (value === 'save') {
                this.saveVarient();
            } else if (value === 'saveAs') {
                this.saveAsVarient();
            } else if (value === 'delete') {
                this.deleteVarient();
            } else {
                this.activeOption = selectedOption[0];
                if (value === 'systemDefault') {
                    Object.keys(this.varientObj).forEach(
                        function(key) {
                        	if(!(key.toLowerCase()==='pageindex' || key.toLowerCase() ==='pagesize'))
                            _this.$store.dispatch('updateObject', {
                                obj: _this.varientObj,
                                attr: key,
                                val: _this.defaultVarient[key]
                            })
                        });
                } else {
                	Object.keys(this.varientObj).forEach(
                        function(key) {
                        	if(!(key.toLowerCase()==='pageindex' || key.toLowerCase() ==='pagesize'))
                            _this.$store.dispatch('updateObject', {
                                obj: _this.varientObj,
                                attr: key,
                                val: _this.currentVarients[_this.activeOption].varient[key]
                            })
                        })
                }
                return;
            }
            this.selectedOptions = [this.activeOption];
        },
        saveVarient() {
            if (this.activeOption === '' || this.activeOption === 'systemDefault') {
                this.saveAsVarient();
            } else {
                this.$confirm('确定覆盖?', 'Warning', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.currentVarients[this.activeOption].varient = JSON.parse(JSON.stringify(this.varient || {}));
                    window.localStorage.setItem('varients', JSON.stringify(this.varients));
                    this.loadVarients();
                }).catch(() => {});

            }
        },
        saveAsVarient() {
            var _this = this;
            this.$prompt('请输入变式名称', '另存为...', {
                cancelButtonText: '取消',
                confirmButtonText: '确认',
            }).then(value => {
                var key = utils.md5(value.value);
                _this.currentVarients[key] = {
                    value: key,
                    label: value.value,
                    varient: JSON.parse(JSON.stringify(_this.varient || {}))
                }
                window.localStorage.setItem('varients', JSON.stringify(_this.varients));
                this.loadVarients();
                this.activeOption = key;
                this.selectedOptions = [key];
            }).catch(() => {});
        },
        deleteVarient() {
            if (this.activeOption === '') {
                this.$alert('请先选择变式', '提醒', {
                    confirmButtonText: '确认',
                    callback: action => {
                        return;
                    }
                });
            } else if (this.activeOption === 'systemDefault') {
                this.$alert('系统默认变式无法删除', '提醒', {
                    confirmButtonText: '确认',
                    callback: action => {
                        return;
                    }
                });
            } else {
                var _this = this;
                this.$confirm('确定删除?', 'Warning', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delete _this.currentVarients[_this.activeOption];
                    _this.activeOption = '';
                    window.localStorage.setItem('varients', JSON.stringify(_this.varients));
                    this.loadVarients();
                }).catch(() => {});
            }
        },
        loadVarients() {
            if (window.localStorage.varients) {
                this.varients = JSON.parse(window.localStorage.varients);
            }
        }
    }
}
</script>

